export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_53-9458f857333943550dbf8334ebdf1744.jpg";